import { FC } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';

export const SaveErrorContent: FC = () => {
    const t = useTranslation();

    return (
        <Flex
            direction="column"
            alignItems="center"
            justifyContent="center"
            flex={1}
            width="100%"
            px={4}
            py={8}
        >
            <Typography variant="title2" weight="bold" textAlign="center">
                {t('Не удалось загрузить данные')}
            </Typography>
        </Flex>
    );
};
